import {defineStore} from 'pinia';
import Cookie from "js-cookie";
import axios from "axios";

// How long a request for the translations may take, and how many times it is tried before the page is shown without them
const REQUEST_TIMEOUT = 8000;
const ATTEMPTS = 2;

export const useLanguagesStore = defineStore({
	id: 'LanguagesStore',
	state: () => ({
		defaultLangSource: 'hu',
		currentLangSource: Cookie.get('lang') ?? 'hu',
		translateKeyPairList: [],
		languages: [],
		loaded: false,
		// The translations could not be loaded: the page is shown in the base language (see FallbackTranslations)
		failed: false,
	}),
	actions: {
		async getTranslationList() {
			this.loaded = false;
			this.failed = false;
			const currentLang = Cookie.get('lang') ?? 'hu';

			for (let attempt = 0; attempt < ATTEMPTS; attempt++) {
				try {
					const response = await axios.get(`/api/localize/${currentLang}`, {timeout: REQUEST_TIMEOUT});
					this.translateKeyPairList = response.data.localize;
					this.languages = response.data.langs;
					this.loaded = true;
					return;
				} catch (error) {
					// Try again once: a short failure of the server or of the network must not leave the page empty
				}
			}

			// The page does not wait for the translations for ever: it is shown, in the base language
			this.failed = true;
			this.loaded = true;
		},
	},
	getters: {
		defaultLang: state => state.defaultLangSource,
		currentLang: state => state.currentLangSource,
		translateList: state => state.translateKeyPairList,
		languageList: state => state.languages,
		isLoaded: (state): boolean => state.loaded,
		hasFailed: (state): boolean => state.failed,
	}
});
